import o from "./_copyObject.js";
import r from "./keysIn.js";
function c(t) {
  return o(t, r(t));
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/toPlainObject.js
// module id = 1531
// module chunks = 41